import {ChangeEvent, KeyboardEvent, useEffect, useState} from 'react';
import {flushSync} from 'react-dom';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {ROUTE} from '@/constants/main/route';
import {HELP_LOG} from '@/constants/help';
import {sendHelpClickLog} from '@/utils/help/log';
import {useFocusElement} from '@/hooks/help/useFocusElement';

export const useSearchArea = () => {
  const navigate = useNavigate();
  const {focusElement} = useFocusElement();
  const [inputValue, setInputValue] = useState('');
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const {value} = e.target;
    setInputValue(value);
  };

  const onClear = () => {
    flushSync(() => {
      setInputValue('');
    });
    focusElement('[class*="SearchBox"] input');
  };

  const [searchParams] = useSearchParams();

  // ROUTE.HELP.SEARCH(검색 결과 페이지)에서 검색하는 경우
  // 페이지 이동이 없어 inputValue가 초기화되지 않음
  // useEffect 사용하여 초기화
  useEffect(() => {
    const q = searchParams.get('q');
    if (q) {
      setInputValue(q);
    }
  }, [searchParams, setInputValue]);

  const sendClickLog = (
    actionType:
      | typeof HELP_LOG.ACTION_TYPE.TO_LIST
      | typeof HELP_LOG.ACTION_TYPE.TO_AUTO,
    text: string,
  ) => {
    sendHelpClickLog(HELP_LOG.CODE_TYPE.SEARCH, {
      buttonType: HELP_LOG.BUTTON_TYPE.SEARCH,
      actionType,
      text,
    });
  };

  const search = () => {
    // 검색어 없는 경우 자주 묻는 질문페이지로, 있는 경우 검색 결과 페이지로 이동
    sendClickLog(HELP_LOG.ACTION_TYPE.TO_LIST, inputValue);
    const path = inputValue
      ? `${ROUTE.HELP.SEARCH}?q=${inputValue}`
      : ROUTE.HELP.FAQ;
    navigate(path);
  };

  const onKeyUp = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter'&& inputValue.trim().length > 0) {
      search();
    }
  };

  return {
    inputValue,
    onChange,
    onClear,
    search,
    onKeyUp,
  };
};
